/* eslint-disable import/prefer-default-export */

export function workerErrorName(message) {
  // Same class as Bugsnag onError naming for unhandled importScripts failures.
  // How to fix: see createWorker.js / getWorkerImportScriptsErrorName in bugsnag.js
  // (lazy init, onerror at create, recreate, notifyErrorSafely instead of throw).
  if (/importScripts/i.test(message) || /NS_BINDING_ABORTED/i.test(message)) {
    return 'WORKER_IMPORTSCRIPTS_LOAD_FAILED';
  }

  return 'WEB_WORKER_RUNTIME_ERROR';
}

export function reportWorkerError(errorEvent, source) {
  const message = errorEvent.message || `${errorEvent.filename || 'worker'}:${errorEvent.lineno || 0}`;
  const filename = errorEvent.filename || 'worker';
  const lineno = errorEvent.lineno || 0;
  const colno = errorEvent.colno != null ? errorEvent.colno : 0;

  const err = new Error(message);
  err.stack = `Error: ${message}\n    at onmessage (${filename}:${lineno}:${colno})`;

  err._meta = { worker: { source, filename, lineno, colno } };
  err._errorName = workerErrorName(message);

  throw err;
}
